import React from "react";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import { Box, Stack, Typography } from "@mui/material";
import { colors } from "../../theme/theme";
import AnalyticsCard from "../../Components/ManageSubs/AnalyticsCard";
import SubscribedUsers from "../../Components/ManageSubs/SubscribedUsers";

const ManageSubscriptions = () => {
  return (
    <Layout>
      <HeadingWithBtns title="Manage Subscriptions" back noSubBtn analytics />

      <Box sx={{ mt: 4 }}>
        <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "23px",
              fontFamily: "Inter-SemiBold",
              color: "#000",
            }}
          >
            Subscription Overview
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              fontFamily: "Inter-SemiBold",
              color: colors.primary,
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Export CSV
          </Typography>
        </Stack>

        <AnalyticsCard />

        <SubscribedUsers />
      </Box>
    </Layout>
  );
};

export default ManageSubscriptions;
